import { io } from 'socket.io-client'

const { REACT_APP_SOCKET_URL = 'https://dev.brujxs.org' } = process.env

let options = {}

/*
const token = localStorage.getItem( 'token' )

if ( token )
  options = { ...options, auth: { token } }
*/

//export const socket = io( REACT_APP_SOCKET_URL, options )

export const socket = io( REACT_APP_SOCKET_URL )
